<template>
  <div class="dialog-form">
    <page-dialog
      @changeDialogVisible="changeDialogVisible"
      :dialogVisible="dialogVisible"
      title="复盘信息"
    >
      <div style="padding: 30px 0;">
        <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="replayPlan"
          label-width="100px"
          class="demo-ruleForm"
          :size="formSize"
          label-suffix="："
        >
          <el-form-item label="提供方案" prop="provideSolutions">
            <el-input placeholder="请输入提供方案" v-model="ruleForm.provideSolutions"></el-input>
          </el-form-item>
          <el-form-item label="收款情况" prop="successfullyReceivedPayment">
            <el-input placeholder="请输入收款情况" v-model="ruleForm.successfullyReceivedPayment"></el-input>
          </el-form-item>
          <el-form-item label="复盘" prop="replay">
            <el-input placeholder="请输入复盘内容" v-model="ruleForm.replay"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="save-btn">
        <el-button type="primary" @click="handleSaveClick(ruleFormRef)">保存</el-button>
      </div>
    </page-dialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { replayPlan } from './config'
import { ElMessage } from 'element-plus'
import { replayContent } from '@/service/main/reserve'
import { useRoute } from 'vue-router'
import router from '@/router'
import emitter from '@/utils/eventbus'
import PageDialog from '@/components/page-dialog/page-dialog.vue'

export default defineComponent({
  props: {
    logId: {
      type: Number,
      default: null
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    logItem: {
      type: Array,
      default: {}
    }

  },
  components: {
    PageDialog
  },
  emits: ['changeDialogVisible','refresh'],
  setup(props, { emit }) {

    const changeDialogVisible = (flag) => {
      emit('changeDialogVisible', flag)
    }
    const route = useRoute()
    const store = useStore()

    const ruleFormRef = ref()

    const ruleForm = reactive({
      replay: '',
      provideSolutions: '',
      successfullyReceivedPayment:''
    })
    watch(() => props.logItem, (newValue) => {
      if (newValue) {
        ruleForm.replay=newValue.replay
        ruleForm.provideSolutions=newValue.provideSolutions
        ruleForm.successfullyReceivedPayment=newValue.successfullyReceivedPayment
      }else{
        ruleForm.replay=''
        ruleForm.provideSolutions=''
        ruleForm.successfullyReceivedPayment=''
      }
    }, {
      deep: true
    })

    const handleSaveClick = async (formEl = undefined) => {
      if (!formEl) return
      await formEl.validate(async (valid, fields) => {
        if (valid) {
          const res = await replayContent({...ruleForm,targetCustomerId:props.logId})
          if (res.code == 0) {
            ElMessage({
              message: '操作成功!',
              type: 'success',
            })
            ruleForm.replay=''
            ruleForm.provideSolutions=''
            ruleForm.successfullyReceivedPayment=''
            changeDialogVisible(false)
            emit('refresh')
          }else {
            ElMessage({
              message: res.msg,
              type: 'error',
            })
          }
        } else {
          ElMessage({
            message: '带*为必填项,请正确填写数据',
            type: 'warning',
          })
        }
      })
    }

    return {
      ruleForm,
      handleSaveClick,
      replayPlan,
      changeDialogVisible,
      ruleFormRef
    }

  }
})
</script>

<style scoped lang="less">
.dialog-form {

  .save-btn {
    text-align: right;
    max-width: 800px;
  }
}
</style>
